import {Box, Text} from "grommet";
import React from "react";
import {faCircleExclamation as IconAlertCircle, faAngleRight as IconArrowRight} from '@fortawesome/pro-light-svg-icons'
import { handleErrors } from "../utils/errors";
import { useRouter } from "next/router";
import FontAwesomeIcon from "./FontAwesomeIcon";
import MessageBanner from "./MessageBanner";

const NotificationBanner = ({notification, onDismiss, containerProps, showDismiss=true, showCTA=true}) => {
    let color;
    switch(notification.priority){
    case 'ok':
        color = 'status-ok';
        break;
    case 'info':
        color = 'status-info';
        break;
    case 'warning':
        color = 'status-warning';
        break;
    case 'critical':
        color = 'status-critical';
        break;
    default:
        color = 'status-ok';
    }

    let icon;
    switch(notification.icon){
    default:
        icon = IconAlertCircle;
    }

    const router = useRouter();

    const onClick = () => {
        if (!notification.action) return;

        try {
            const url = new URL(notification.action, window.location.origin);
            const isExternalLink = url.hostname !== window.location.hostname;

            if (isExternalLink) {
                window.open(notification.action, '_blank');
            } else {
                router.push(url.pathname + url.search);
            }
        } catch {
            router.push(notification.action);
        }
    }

    const markNotificationAsRead = () => {
        fetch("/api/notifications/mark_as_read", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: notification.id
            })
        }).then(handleErrors).then(() => {
            onDismiss && onDismiss();
        })
    }

    const ctaText = showCTA ? (
        <Box direction="row" align="center" justify="between" gap="xsmall">
            <Text weight={450}>Review</Text>
            <FontAwesomeIcon SelectedIcon={IconArrowRight} size="xsmall"/>
        </Box>
    ) : undefined;

    return (
        <MessageBanner
            message={<Text wordBreak="break-word" weight={450}>{notification.message}</Text>}
            color={color}
            icon={icon}
            ctaText={ctaText}
            onClick={showCTA ? onClick : undefined}
            onDismiss={showDismiss ? markNotificationAsRead : undefined}
            containerProps={{margin: {bottom: 'small'}, ...containerProps}}
            iconProps={{
                customSize: "24px",
                border: { color, size: "medium" },
                iconContainerProps: { width: {min: "24px"} },
            }}
            innerContainerProps={{pad: 'xsmall'}}
        />
    );
};

export default NotificationBanner;
